(() => {
    const rootList = document.querySelectorAll('.js--slider-wrap');
    if (!rootList.length) return;

    rootList.forEach((root) => {
        const track = root.querySelector('.infinite-slider__track');
        const set = root.querySelector('.infinite-slider__set');
        if (!track || !set) return;

        // 既に複製済みなら二重複製を避ける
        if (track.querySelectorAll('.infinite-slider__set').length >= 2) return;

        const clone = set.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');

        // 複製側のimg altを空にして読み上げ重複を防ぐ
        clone.querySelectorAll('img').forEach((img) => {
            img.setAttribute('alt', '');
        });

        track.appendChild(clone);
    });
})();
